import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Styles for the GroundingRemoveResourceDialog
 */ export const useGroundingRemoveResourceDialogStyles = makeStyles({
    root: {
        maxWidth: "600px"
    },
    message: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        marginBottom: tokens.spacingVerticalL
    },
    dialogActions: {
        gap: tokens.spacingHorizontalM,
        justifyContent: "flex-end"
    },
    actionButton: {
        borderRadius: tokens.borderRadiusXLarge,
        minWidth: 0
    }
});
